import { IconButton, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Draggable from 'react-draggable';

export const ErrorPopUp = (props) => {
  const { error, setError, errorText } = props;
  const [opacity, setOpacity] = useState(1);
  useEffect(() => {
    if (error) {
      setOpacity(1);
    }
  }, [error]);
  const handleDrag = (e, ui) => {
    const { y } = ui;

    const newOpacity = 1 - Math.min(Math.abs(y) / 68, 1);
    setOpacity(newOpacity);
  };
  return (
    <div>
      {Boolean(error) && (
        <Draggable
          onDrag={handleDrag}
          axis="y"
          scale={0.7}
          defaultClassNameDragging="custom-draggable-popup"
          onStop={() => {
            if (opacity < 0.2) setError(false);
          }}
        >
          <div
            onPointerUp={(e) => {
              e.preventDefault();
              e.stopPropagation();

              setError(false);
            }}
            style={{
              justifyContent: 'flex-start',
              textAlign: 'left',
              position: 'fixed',
              backgroundColor: '#FF2D2D',
              marginTop: '20px',
              boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
              borderRadius: '10px',
              padding: '15px',
              display: 'flex',
              flexDirection: 'row',
              gap: '14px',
              zIndex: 9999,
              top: '0px',
              width: 'calc(100% - 64px)',
              maxWidth: `calc(${
                (document?.getElementById('layout-container')?.offsetWidth ||
                  390) + 'px - 32px'
              })`,
              left: 0,
              right: 0,

              marginInline: 'auto',
              opacity: opacity,
            }}
          >
            <IconButton
              onClick={() => {
                setError(false);
              }}
              sx={{
                padding: 0,
                width: '21px',
                height: '21px',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="22"
                viewBox="0 0 21 22"
                fill="none"
              >
                <path
                  d="M10.498 0.235107C4.6983 0.235107 0 4.9334 0 10.7331C0 16.5329 4.6983 21.2312 10.498 21.2312C16.2978 21.2312 20.9961 16.5329 20.9961 10.7331C20.9961 4.9334 16.2978 0.235107 10.498 0.235107Z"
                  fill="white"
                />
                <path d="M14 7L7 14" stroke="#FF2D2D" stroke-width="2" />
                <path d="M7 7L14 14" stroke="#FF2D2D" stroke-width="2" />
              </svg>
            </IconButton>

            <Typography
              sx={{
                color: 'white',
                fontWeight: '500',
                fontSize: '14px',
                lineHeight: '21px',
              }}
            >
              {errorText}
            </Typography>
          </div>
        </Draggable>
      )}
    </div>
  );
};
